export default __webpack_public_path__ + "static/media/WWG_Logo.95098909.svg";